import React from 'react';
import { IndianRupee } from 'lucide-react';
import ExportDropdown from './ExportDropdown';

const Header = ({ onSettlementClick, onDownloadReport, eventPayLoading }) => {
  return (
    <div className="mb-10">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="space-y-2">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg shadow-md">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Event Payment Reports</h1>
              <p className="text-gray-600 mt-1 flex items-center gap-2">
                <span className="flex h-2 w-2">
                  <span className="relative h-2 w-2 rounded-full bg-blue-500"></span>
                </span>
                View and manage event payment records and transactions
              </p>
            </div>
          </div>
        </div>
        <div className="md:flex gap-3 ">
          <button
            onClick={() => onSettlementClick(null)}
            className="group md:my-0 my-3 relative inline-flex items-center px-4 py-2.5 bg-gradient-to-r from-cyan-800 to-blue-900 text-white rounded-xl font-medium hover:shadow-lg transition-all duration-200 shadow-md"
          >
            <IndianRupee size={20} className="mr-2 group-hover:scale-110 transition-transform" />
            Settlement Details
            <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-cyan-400 to-blue-400 opacity-0 group-hover:opacity-100 transition-opacity"></div>
          </button>
          <ExportDropdown
            label="Download Full Report"
            variant="primary"
            handleDownloadReport={onDownloadReport}
            eventPayLoading={eventPayLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;